import React, { useEffect, useMemo, useState } from 'react';
import './index.scss';
import { IPermissionContentProps } from '../../interface';
import { getPermissionList } from '@umu/umu-api';
import { PermissionType } from '../../../../interface';
import { shareOptionMap } from './../../../../dataFlow';
import { getCourseInfo, getCourseTimingSwitchInfo } from '../../../../server';
import { If } from 'common/src/components';
import { lang } from '@umu/ukit-lang';
import dayjs from 'dayjs';
import { localeConfig } from 'common/src/services/localeConfig';
import { PermissionMemberList } from '../../../memberList';
import { Button } from '@umu/umu-design';

const defaultTimingInfo = {
    close_time: 0,
    open_access_permission: '0',
    open_time: 0,
};
const dateDisplayFormat = localeConfig.dateDisplayFormat.replace('dddd ', '').replace('ddd, ', '');
const CoursePermissionInfo = (props: IPermissionContentProps) => {
    const {
        id,
        prefixCls = 'course-permission-info',
        showRefresh = false,
        normalizeAccountEPU,
        normalizeAccountName,
    } = props;
    const [dataInfo, setDataInfo] = useState<any>({
        permission: PermissionType.__INIT__,
        courseInfo: null,
        timingSwitchInfo: null,
    });
    const [isReload, setIsReload] = useState(false);

    const onInit = (callBack?: () => void) => {
        Promise.all([
            getPermissionList({
                obj_id: id,
                obj_type: 'group',
            }),
            getCourseInfo({
                group_id: id,
            }),
            getCourseTimingSwitchInfo({
                course_id: id,
            }),
        ]).then(([permissionInfo, courseInfo, timingSwitchInfo]) => {
            setDataInfo({
                permission: permissionInfo.selected as PermissionType,
                courseInfo,
                timingSwitchInfo,
            });
            callBack?.();
        });
    };
    useEffect(() => {
        onInit();
    }, [id]);
    const onRefresh = () => {
        if (props?.onRefresh) {
            props?.onRefresh?.();
        }
        setIsReload(false);
        onInit(() => {
            setIsReload(true);
        });
    };
    const accessPermissionTips = dataInfo?.courseInfo?.groupInfo?.setup?.accessPermissionTips || '';

    const { label, isShowCloseText, isShowAccount, labelSuffix } = useMemo(() => {
        const permission = String(dataInfo.permission) as PermissionType;
        return {
            label: shareOptionMap?.[permission]?.customLabel,
            labelSuffix: showRefresh ? (
                <Button type="text" className="btn-split" isOnlyChildren onClick={onRefresh}>
                    {lang('刷新')}
                </Button>
            ) : (
                ''
            ),
            isShowCloseText: permission === PermissionType.NONE_ALL && accessPermissionTips !== '',
            isShowAccount: permission === PermissionType.DESIGNATED_ACCOUNT,
        };
    }, [dataInfo.permission]);

    const { isShowTimingInfo, timingTitle, isShowTimingCloseTips, timingDesc, isShowTimingAccount } = useMemo(() => {
        const { close_time, open_access_permission, open_time } = dataInfo.timingSwitchInfo || defaultTimingInfo;
        const isOpen = Number(open_time) > 0;
        const isClose = Number(close_time) > 0;
        const openPermission = open_access_permission as PermissionType;
        return {
            isShowTimingCloseTips: isClose && accessPermissionTips !== '',
            isShowTimingInfo: isOpen || isClose,
            isShowTimingAccount: isOpen && String(openPermission) === PermissionType.DESIGNATED_ACCOUNT,
            timingTitle: isOpen
                ? `${lang('自动开启：')} ${dayjs(Number(open_time) * 1000).format(dateDisplayFormat)}`
                : `${lang('自动关闭：')} ${dayjs(Number(close_time) * 1000).format(dateDisplayFormat)}`,
            timingDesc: isOpen ? `${lang('开启后权限：')} ${shareOptionMap?.[openPermission]?.customLabel}` : '',
        };
    }, [dataInfo.timingSwitchInfo]);
    return (
        <div className={prefixCls}>
            <div className={`${prefixCls}-rows-split`}>
                {label}
                {labelSuffix}
            </div>
            <If condition={isShowCloseText}>
                <div className={`${prefixCls}-rows-split`}>{`${lang('关闭提示语：')} ${accessPermissionTips}`}</div>
            </If>
            <If condition={isShowTimingInfo}>
                <div className={`${prefixCls}-rows-split ${prefixCls}-timing-info`}>
                    <div className={`${prefixCls}-rows-split`}>{timingTitle}</div>
                    {timingDesc && <div className={`${prefixCls}-rows-split`}>{timingDesc}</div>}
                    {isShowTimingCloseTips && <div>{`${lang('关闭提示语：')} ${accessPermissionTips}`}</div>}
                </div>
            </If>
            <If condition={isShowAccount || isShowTimingAccount}>
                <PermissionMemberList
                    isModeView
                    id={id}
                    isReload={isReload}
                    sourceType={'group'}
                    normalizeAccountEPU={normalizeAccountEPU}
                    normalizeAccountName={normalizeAccountName}
                />
            </If>
        </div>
    );
};
export { CoursePermissionInfo };
